
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKURepricingBOMGrid extends Serenity.EntityGrid<SKURepricingBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.SKURepricingBOM'; }
        protected getDialogType() { return SKURepricingBOMDialog; }
        protected getIdProperty() { return SKURepricingBOMRow.idProperty; }
        protected getInsertPermission() { return SKURepricingBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return SKURepricingBOMRow.localTextPrefix; }
        protected getService() { return SKURepricingBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}